"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var constants_1 = require("../../../constants");

var Image_1 = __importDefault(require("../../Card/Image"));

var Pill_1 = __importDefault(require("../../Card/Pill"));

var Section_1 = __importDefault(require("../../Card/Section"));

var Mirador_1 = __importDefault(require("../../Mirador"));

var Transition_1 = __importDefault(require("../../Transition"));

var SideBar_1 = __importDefault(require("../SideBar"));

var Shelf_1 = __importDefault(require("./Shelf"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
* Library Moment to interactively visualize works and publications.
*/


var LibraryMoment = function LibraryMoment(props) {
  var color = props.color,
      data = props.data;
  var classes = (0, useStyles_1.default)();

  var _a = (0, react_1.useState)(undefined),
      currentBook = _a[0],
      setBook = _a[1];

  var _b = (0, react_1.useState)(false),
      sidebar = _b[0],
      setSidebar = _b[1];

  var _c = (0, react_1.useState)(false),
      dialog = _c[0],
      setDialog = _c[1];

  var handleCloseSidebar = function handleCloseSidebar() {
    return setSidebar(false);
  };

  var handleSelectBook = function handleSelectBook(book) {
    setBook(book);
    setSidebar(true);
  };

  var handleOpenDialog = function handleOpenDialog() {
    handleCloseSidebar();
    setDialog(true);
  };

  var handleCloseDialog = function handleCloseDialog() {
    setDialog(false);
    setSidebar(true);
  };

  var renderMirador = function renderMirador() {
    if (!(currentBook && currentBook.manifest_url)) return undefined;
    var manifestId = currentBook.manifest_url,
        _a = currentBook.provider,
        provider = _a === void 0 ? 'IIIF Resource' : _a;
    var config = {
      manifests: {},
      windows: [{
        manifestId: manifestId,
        view: 'gallery'
      }]
    };
    config.manifests[manifestId] = {
      provider: provider
    };
    return react_1.default.createElement(Mirador_1.default, {
      className: classes.mirador,
      config: config
    });
  };

  var renderDialog = function renderDialog() {
    return react_1.default.createElement(Dialog_1.default, {
      className: "story-library-dialog",
      classes: {
        paper: classes.dialog
      },
      onClose: handleCloseDialog,
      open: dialog,
      TransitionComponent: Transition_1.default
    }, renderMirador());
  };

  var renderSideBarContent = function renderSideBarContent() {
    if (!currentBook) return undefined;
    var date = currentBook.date,
        description = currentBook.description,
        image = currentBook.image,
        instance = currentBook.instance,
        label = currentBook.label,
        manifestURL = currentBook.manifest_url,
        url = currentBook.url;
    return react_1.default.createElement(Grid_1.default, {
      className: classes.sideBar,
      container: true,
      justifyContent: "center",
      spacing: 5
    }, react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 10
    }, react_1.default.createElement(Typography_1.default, {
      variant: "h5"
    }, label)), react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 12
    }, react_1.default.createElement(Divider_1.default, {
      variant: "middle"
    })), instance && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 10
    }, react_1.default.createElement(Typography_1.default, {
      variant: "h6"
    }, instance)), date && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 10
    }, react_1.default.createElement(Pill_1.default, {
      text: date.label
    })), image && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 10
    }, react_1.default.createElement(Image_1.default, {
      alt: label,
      src: image
    })), description && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 12
    }, react_1.default.createElement(Section_1.default, null, description)), manifestURL && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 4
    }, react_1.default.createElement(Button_1.default, {
      className: "library-sidebar-link",
      onClick: handleOpenDialog,
      style: {
        background: color.background,
        color: color.text
      },
      variant: "contained"
    }, "Look Inside")), url && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 4
    }, react_1.default.createElement(Button_1.default, {
      className: "library-sidebar-link",
      href: url,
      target: "_blank",
      variant: "contained"
    }, "Learn More")));
  };

  var shelfKey = function shelfKey(name, index) {
    return "lib-shelf-" + name + "-" + index;
  };
  /* eslint-disable react/jsx-props-no-spreading */


  return react_1.default.createElement(SideBar_1.default, __assign({}, props, {
    bodyClassName: classes.library,
    onClose: handleCloseSidebar,
    sidebar: sidebar,
    sideBarContent: renderSideBarContent()
  }), Object.entries(data).map(function (_a, index) {
    var shelfName = _a[0],
        shelf = _a[1];
    return react_1.default.createElement(Shelf_1.default, __assign({
      key: shelfKey(shelfName, index),
      onSelect: handleSelectBook
    }, shelf));
  }), renderDialog());
};

LibraryMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Stories-API data context to configure the `LibraryShelf` components. */
  // eslint-disable-next-line react/forbid-prop-types
  data: prop_types_1.default.object.isRequired,

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: prop_types_1.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
LibraryMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  data: {},
  layout: constants_1.MomentLayout.Library,
  type: constants_1.MomentType.Library
});
exports.default = LibraryMoment;